import { cn } from "@shared/lib/cn";

/*
 * Крутилка.
 *
 * От генератора приехал `Loader2Icon` из Lucide с `animate-spin` — пунктирная
 * дуга. Здесь вместо него кольцо системы: ровная окружность цвета рамки с
 * акцентной верхушкой. Это не вкусовщина и не упрямство — вид берётся из
 * макета, а компонент из shadcn нужен ради границы, а не ради внешности. Ровно
 * так же сделаны `Input` и `Button`: структура оттуда, оформление наше.
 *
 * Размер приходит свойством, а не классом: крутилка стоит и в строке текста
 * (14px), и посреди пустого экрана (18px), и толщина кольца должна расти
 * вместе с ней — на классе это два набора правил вместо одного счёта.
 */
function Spinner({
  size = 14,
  className,
  style,
  ...props
}: React.ComponentProps<"span"> & { size?: number }) {
  return (
    <span
      data-slot="spinner"
      role="status"
      aria-label="Загрузка"
      className={cn("inline-block shrink-0 rounded-full border-border-strong", className)}
      style={{
        width: size,
        height: size,
        // Толщина — седьмая часть поперечника: при 14px это ровно 2px, как
        // было в `.spin`, а на других размерах кольцо не расползается.
        borderWidth: Math.max(2, Math.round(size / 7)),
        borderStyle: "solid",
        borderTopColor: "var(--ui-accent)",
        animation: "spin 0.7s linear infinite",
        ...style,
      }}
      {...props}
    />
  );
}

export { Spinner };
